<template>
<div>
  <Head :active="'corporations'" />
  <banner />
  <div class="policy">
    <div class="banner"><img src="" width="100%"></div>
    <!-- <div class="policy-head">
      {{policyList}}
    </div> -->
    <router-view :informationList="policyList" />
  </div>
  <Footer />
</div>
</template>

<script>
import axios from 'axios'
import Head from '../../components/header.vue'
import banner from '../../components/banner.vue'
import Footer from '../../components/footer.vue'
export default {
  components: {
    Head,
    banner,
    Footer
  },
  data () {
    return {
      page: 1,
      totalPage: 0,
      pageSize: 8,
      count: 0,
      newList: [],
      policyList: []
    }
  },
  // // 本地获取
  // mounted () {
  //   this.policyList = require('../example/example.json')
  //   console.log(this.policyList)
  //   // this.renderList()
  //   // console.log(this.count, this.totalPage)
  // }
  mounted () {
    axios.get('https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/example.json')
      .then(response => {
        this.policyList = response.data
      })
    // console.log(this.policyList)
  }
}
</script>

<style lang="less" scoped>
a {
  color: #999;
}
.policy {
  position: relative;
  // padding: 40px 0 50px 0;
  // margin: 0 10%;
  .policy-head {
    position: relative;
    padding: 0 10px;
    height: 60px;
    border-bottom: 1px solid #ddd;
    line-height: 60px;
    h1 {
      color: #555;
      font-weight: normal;
      font-size: 18px;
    }
    &-right {
      position: absolute;
      top: 0;
      right: 10px;
      color: #aaa;
    }
  }
  .policy-list {
    padding: 0 10px;
    // height: 60px;
    // border-bottom: 1px solid #ddd;
    line-height: 60px;
    .list-item {
    border-bottom: 1px solid #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/example/example.vue